<template>
<div id="app">
  <router-view />
</div>
</template>

<script>
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  });
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
};
import vuexInit from './utils/vuexInit'
export default {
  name: "App",
  mounted() {
    this.setInit()
    window.addEventListener('resize',this.screenSize())
    this.$router.onReady(() => {
      if (this.$route.params.plat_type) {
        this.$store.commit('SET_PLAT', this.$route.params.plat_type);
      }
    })
  },
  watch:{
    $route() {
      this.$request.userOnly()
    },
    '$route.params.plat_type'(){
      if (this.$route.params.plat_type) {
        this.$store.commit('SET_PLAT', this.$route.params.plat_type);
      }
    }
  },
  methods:{
    screenSize(){
      let screenWidth = window.innerWidth;
      let hash = window.location.hash
      let windowUrl = window.location.href
      let url = ''
      if(screenWidth > 750){
        url = windowUrl.replace('/edu_h5/','/edu/')
        if(hash.indexOf('userYingyou/setting')>-1){ //个人中心
          url = url.replace('userYingyou/setting','myCenter')
        }else if(hash.indexOf('lessonYingyouZT')>-1){//课程列表
          url = url.replace('lessonYingyou','LessonTuoyu')
        }else if(hash.indexOf('lessonYingyou')>-1){//课程列表
          url = url.replace('lessonYingyou','LessonTuoyu')
        }else if(hash.indexOf('detailYingyou')>-1){//课程详情
          url = url.replace('detailYingyou','detail2')
        }else if(hash.indexOf('playerYingyou')>-1){//视频播放
          url = url.replace('playerYingyou','player2')
        }
        window.location.replace(url)
      }
    },
    setInit(){
      let arr = ['indexTab2', 'indexTab', 'platMap']
      arr.forEach(item=>{
        this.$store.commit('SET_INIT',{name:item,data:vuexInit[item]})
      })
    }
  }
};
</script>

<style lang="scss">
.ellipsis_three {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: pre-wrap;
}
  .price{
    font-size: 24px !important;
    font-weight: normal !important;
  }
  .tip{
    display: none;
  }
.van-image__loading-icon,.van-image__error{
    width: 100%;
    height: 100%;
    .van-icon__image{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

p {
  margin: 0;
}

#app {
  height: 100%;

  .van-tabs__line {
    // width: 75px;
    height: 5px;
    border-radius: 2px;
  }

  .van-nav-bar--fixed {
    z-index: 1600;
  }
}

.footer {
  font-size: 13px;
  font-weight: 400;
  color: #999999;
  bottom: 15px;
  position: fixed;
  left: 0;
  width: 100%;
}

.ccH5PlayBtn {
  width: 85px !important;
  background: url("https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/play_icon.png") no-repeat center !important;
  background-size: 85px !important;
}

.prism-big-play-btn {
  width: 85px !important;
  background: url("https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/play_icon.png") no-repeat center !important;
  background-size: 85px !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
}

.prism-big-play-btn .outter {
  display: none;
}

.van-tabbar-item {
  font-size: 24px !important;
}

/*每个页面公共css */
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ellipsis_two {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: pre-wrap;
}

.part-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 30px 25px;
}
.part-title2 {
  padding-top:25px
}
.part-title_text {
  font-size: 36px;
  color: #333;
  font-weight: 600;
}

.part-title_more {
  font-size: 28px;
  color: #888888;
}

.index-tab .van-tab--active {
  font-size: 36px !important;
}

.detail-page .van-tab {
  font-size: 32px !important;
}

.detail-page .tab-content>.van-tabs .van-tabs__wrap {
  padding: 0;
  height: 210px !important;
}

.detail-page .tab-content>.van-tabs .van-tabs__line {
  display: none;
}

.detail-page .tab-content>.van-tabs .van-tab {
  display: block;
  padding: 0 10px;
}
/*
.detail-page .van-tabs__wrap {
  padding: 0 60px;
}
*/
.van-tabs--line .van-tabs__wrap {
  height: 88px !important;
}

.big-btn {
  width: 646px;
  height: 105px;
  background: #a40001;
  border-radius: 53px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 36px;
  letter-spacing: 11px;
  font-weight: 600;
}

body {
  max-width: 750px;
  margin: 0 auto;
  padding-top: constant(safe-area-inset-top);
  padding-left: constant(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-bottom: constant(safe-area-inset-bottom);
}

  .myTabs{
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
.nodata{
  p{
    font-size: 28px;
    font-weight: 600;
    color: #000000;
    line-height: 40px;
    margin-bottom: 10px;
  }
  span{
    font-size: 24px;
    font-weight: 400;
    color: #999999;
    line-height: 34px;
  }
}
.nodata {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  flex-direction: column;
  font-weight: 400;
  color: #9fa2b3;
  line-height: 42px;
}

.nodata>img {
  width: 338px;
  margin-bottom: 32px;
}

.html-view img {
  width: 100%;
  display: block;
  vertical-align: middle;
}

.html-view p {
  width: 100%;
  display: block;
  vertical-align: middle;
}

.index-tab-header {
  width: 100vw;
  background: transparent;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}

.index-tab-header .van-tab--disabled {
  // color: #666 !important;
}

.index-tab-header .van-tab {
  padding: 0 30px !important;
  // color: #666 !important;
  font-size: 32px !important;
}

.index-tab-header .van-tab--active {
  font-size: 32px !important;
  font-weight: bold !important;
  // color: #333 !important;
}

.type-select {
  /* height: 115px; */
  min-height: 100px;
  padding: 20px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #fff;
}

.type-select_line {
  border-bottom: 1px solid #E4E5E6;
  width: 686px;
  margin: 0 auto;
}

div.type-select .van-tab {
  padding: 9px 24px;
  box-sizing: border-box;
  color: #333;
  font-size: 26px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 6px;
}

.type-select .van-tabs__line {
  display: none !important;
}

.type-select .van-tabs__wrap {
  height: 100% !important;
}

div.type-select .van-tab--active {
  background: #F6F7F8;
  border-radius: 28px;
  color: #A40001;
  font-weight: 500;
}
</style>
